import { IncidentService } from '@/api/services/IncidentService';
import { IncidentScope } from '@/api';
import callWithContext from '@/api/call-with-context';
import { ToolDefinition } from '../types';

const getIncidentScopeTool: ToolDefinition = {
  name: 'get_incident_scope_by_issue_number',
  description: 'Get incident scope by issue number. Use for scope, affected assets, compromised datasets, or monitors/rules. Returns affected assets, monitors, related entities.',
  input_schema: {
    type: 'object',
    properties: {
      issue_number: {
        type: 'integer',
        description: 'Incident issue number (e.g., 1234). Use to get scope, check affected assets, or get monitor details.',
      },
    },
    required: ['issue_number'],
  },
};

/**
 * Execute the get_incident_scope_by_issue_number tool
 */
export async function executeGetIncidentScopeByIssueNumber(
  params: { issue_number: number },
): Promise<IncidentScope | { error: string; missingParam?: string }> {
  try {
    const { issue_number: issueNumber } = params;

    // Check for required parameters and return error as result for Claude to iterate
    if (!issueNumber) {
      return {
        error: 'issue_number is required',
        missingParam: 'issue_number',
      };
    }

    const result = await callWithContext('sifflet-ai-chat', () => IncidentService.getIncidentScopeByIssueNumber({
      issueNo: issueNumber,
    }));

    return result;
  } catch (error) {
    return { error: (error as Error).message };
  }
}

export default getIncidentScopeTool;
